import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import '../styles/languageSelector.css';

const languages = [
  { code: 'nl', label: 'Nederlands', countryCode: 'NL' },
  { code: 'en', label: 'English', countryCode: 'GB' },
  { code: 'fr', label: 'Français', countryCode: 'FR' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null); // ref for the dropdown wrapper

  const location = useLocation();
  const isCheckout = location.pathname === '/checkout';

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  const handleSelect = (code) => {
    if (isCheckout) return;

    i18n.changeLanguage(code);
    localStorage.setItem('appLanguage', code);
    setOpen(false);
  };

  useEffect(() => {
    const savedLang = localStorage.getItem('appLanguage');
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }

    if(!languages.some(l => l.code === i18n.language)){
      if(i18n.language){
        languages.find((l) => l.code === i18n.language.split('-')[0])?.code ? i18n.changeLanguage(languages.find((l) => l.code === i18n.language.split('-')[0]).code) : i18n.changeLanguage('en');
      }
    }
  }, [i18n]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="language-dropdown" ref={dropdownRef}>
      <button
        className="language-button"
        onClick={() => !isCheckout && setOpen(!open)}
        disabled={isCheckout}
        aria-haspopup="true"
        aria-expanded={open}
      >
        <ReactCountryFlag
          countryCode={currentLang.countryCode}
          svg
          style={{ width: '1.3em', height: '1.3em', marginRight: '0.5rem' }}
        />
        <span className="language-label">{currentLang.label}</span>
        <span className={`arrow ${open ? 'up' : 'down'}`} />
      </button>

      {open && (
        <ul className="language-menu">
          {languages.map((lang) => (
            <li key={lang.code} onClick={() => handleSelect(lang.code)}>
              <ReactCountryFlag
                countryCode={lang.countryCode}
                svg
                style={{ width: '1.3em', height: '1.3em', marginRight: '0.6rem' }}
              />
              {lang.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;